import React from "react";
import Carousel from "../../../components/Carousel";
import MobileHeader from "../../../components/MobileHeader";
import YoutubeSection from "../../../components/YoutubeSection";
import MainSection from "../MainSection";
import "./style.scss";

const MobileMainPage = () => {
  return (
    <div>
      <MobileHeader />
      {/* <MainSection /> */}
      {/* <img className="imgs" src="/img/pages/mobile-slide-0.jpg" /> */}
       
       <Carousel device="mobile" />
 
      <YoutubeSection device="mobile" />
      <img className="imgs" src="/img/pages/m-11.jpg" />
      <img id="doctor" className="imgs" src="/img/pages/m-12.jpg" />
      <img id="subject" className="imgs" src="/img/pages/m-13.jpg" />
      <img id="special" className="imgs" src="/img/pages/m-14-new.jpg" />
      <img id="info" className="imgs" src="/img/pages/m-15.jpg" />
      <img className="imgs" src="/img/pages/m-16.jpg" />
      <img className="imgs" src="/img/pages/m-17.jpg" />
      <img id="location" className="imgs" src="/img/pages/m-18.jpg" />
      <footer className="footer-cn">
        <div className="logo-cn">
          <img className="footer-log" src="/img/footer_logo.png" />
        </div>
        <div>
          <p>
            <span>상호명</span>바른정플란트치과의원 북구화명점
          </p>
        </div>
        <div>
          <p>
            <span>대표</span>김형우
          </p>
          <p>
            <span>사업자등록번호</span>606-39-04901
          </p>
        </div>
        <div>
          <p>
            <span>주소</span>부산 북구 금곡대로 199번길3, 화명메디칼빌딩 5층
          </p>
        </div>
        <div>
          <p>
            <span>전화번호</span>051-365-2275
          </p>
        </div>
        <div>
          <p>CopyrightⓒBARENJUNGPLANT Rights Reserved.</p>
        </div>
        <div
          className="fee-cn"
          onClick={() => {
            window.open(
              "https://m.blog.naver.com/PostView.naver?blogId=3652275&logNo=222424577668&navType=by",
              "_blank"
            );
          }}
        >
          <p>비급여수가표 바로가기</p>
        </div>
      </footer>
    </div>
  );
};

export default MobileMainPage;
